import React, { useState } from "react";
import "./Add_Money.css";
import Add_Money_Modal from "./add-money-modal/Add_Money_Modal";
const Add_Money = () => {
  const [isSelected, setIsSelected] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const toggleSelection = () => {
    setIsSelected(!isSelected);
  };
  const handleAddMoneyClick = () => {
    setShowModal(true);

    setTimeout(() => {
      setShowModal(false);
    }, 3000);
  };
  return (
    <div className="add-money-container container">
      <div className="add-money-card">
        <h2 className="add-money-title">Wallet</h2>
        <div className="add-money-balance-box">
          <span className="add-money-balance-amount">₹1500</span>
          <span className="add-money-balance-label">BALANCE</span>
        </div>
        <div className="add-money-input-group">
          <label className="add-money-label">Enter Amount</label>
          <input
            type="text"
            className="add-money-input-field"
            defaultValue="₹200.00"
          />
        </div>
        <div className="add-money-payment-group">
          <label className="add-money-label">Payment method</label>
          <div
            className="add-money-payment-option"
            onClick={toggleSelection}
            style={{
              cursor: "pointer",
              borderColor: isSelected ? "#0056a4" : "#ccc",
            }}
          >
            <div className="add-money-payment-logo">
              <img src="/assets/images/Razorpay_img.png" alt="razorpay" />
            </div>
            <div className="add-money-radio-circle">
              {isSelected && <div className="add-money-radio-inner"></div>}
            </div>
          </div>
        </div>
        <button className="add-money-add-button" onClick={handleAddMoneyClick}>
          Add Money
        </button>
      </div>
      <Add_Money_Modal
        showAddMoney={showModal}
        handleAddMoneyClose={() => setShowModal(false)}
      />
    </div>
  );
};

export default Add_Money;
